var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5506 15.177C15.7213 14.7996 15.5537 14.3553 15.1762 14.1846C14.7988 14.014 14.3545 14.1816 14.1839 14.559L15.5506 15.177ZM13.5 15.75L13.5002 15H13.5V15.75ZM3 5.25H3.75L3.75 5.24959L3 5.25ZM4.19063 4.56597C4.56796 4.39511 4.73533 3.95071 4.56447 3.57338C4.39361 3.19605 3.94921 3.02867 3.57188 3.19953L4.19063 4.56597ZM6.75 3C6.33579 3 6 3.33579 6 3.75C6 4.16421 6.33579 4.5 6.75 4.5V3ZM14.25 12C14.25 12.4142 14.5858 12.75 15 12.75C15.4142 12.75 15.75 12.4142 15.75 12H14.25ZM14.1839 14.559C14.0624 14.8276 13.795 15.0001 13.5002 15L13.4998 16.5C14.384 16.5003 15.1863 15.9827 15.5506 15.177L14.1839 14.559ZM13.5 15H4.5V16.5H13.5V15ZM4.5 15C4.08579 15 3.75 14.6642 3.75 14.25H2.25C2.25 15.4926 3.25736 16.5 4.5 16.5V15ZM3.75 14.25V5.25H2.25V14.25H3.75ZM3.75 5.24959C3.74984 4.95495 3.92222 4.68751 4.19063 4.56597L3.57188 3.19953C2.76665 3.56415 2.24952 4.36648 2.25 5.25041L3.75 5.24959ZM6.75 4.5H13.5V3H6.75V4.5ZM13.5 4.5C13.9142 4.5 14.25 4.83579 14.25 5.25H15.75C15.75 4.00736 14.7426 3 13.5 3V4.5ZM14.25 5.25V12H15.75V5.25H14.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5506 15.177C15.7213 14.7996 15.5537 14.3553 15.1762 14.1846C14.7988 14.014 14.3545 14.1816 14.1839 14.559L15.5506 15.177ZM13.5 15.75L13.5002 15H13.5V15.75ZM3 5.25H3.75L3.75 5.24959L3 5.25ZM4.19063 4.56597C4.56796 4.39511 4.73533 3.95071 4.56447 3.57338C4.39361 3.19605 3.94921 3.02867 3.57188 3.19953L4.19063 4.56597ZM6.75 3C6.33579 3 6 3.33579 6 3.75C6 4.16421 6.33579 4.5 6.75 4.5V3ZM14.25 12C14.25 12.4142 14.5858 12.75 15 12.75C15.4142 12.75 15.75 12.4142 15.75 12H14.25ZM14.1839 14.559C14.0624 14.8276 13.795 15.0001 13.5002 15L13.4998 16.5C14.384 16.5003 15.1863 15.9827 15.5506 15.177L14.1839 14.559ZM13.5 15H4.5V16.5H13.5V15ZM4.5 15C4.08579 15 3.75 14.6642 3.75 14.25H2.25C2.25 15.4926 3.25736 16.5 4.5 16.5V15ZM3.75 14.25V5.25H2.25V14.25H3.75ZM3.75 5.24959C3.74984 4.95495 3.92222 4.68751 4.19063 4.56597L3.57188 3.19953C2.76665 3.56415 2.24952 4.36648 2.25 5.25041L3.75 5.24959ZM6.75 4.5H13.5V3H6.75V4.5ZM13.5 4.5C13.9142 4.5 14.25 4.83579 14.25 5.25H15.75C15.75 4.00736 14.7426 3 13.5 3V4.5ZM14.25 5.25V12H15.75V5.25H14.25Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25V5.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25V3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25V3",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5C2.58579 7.5 2.25 7.83579 2.25 8.25C2.25 8.66421 2.58579 9 3 9V7.5ZM8.25 9C8.66421 9 9 8.66421 9 8.25C9 7.83579 8.66421 7.5 8.25 7.5V9ZM11.25 7.5C10.8358 7.5 10.5 7.83579 10.5 8.25C10.5 8.66421 10.8358 9 11.25 9V7.5ZM15 9C15.4142 9 15.75 8.66421 15.75 8.25C15.75 7.83579 15.4142 7.5 15 7.5V9ZM3 9H8.25V7.5H3V9ZM11.25 9H15V7.5H11.25V9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5C2.58579 7.5 2.25 7.83579 2.25 8.25C2.25 8.66421 2.58579 9 3 9V7.5ZM8.25 9C8.66421 9 9 8.66421 9 8.25C9 7.83579 8.66421 7.5 8.25 7.5V9ZM11.25 7.5C10.8358 7.5 10.5 7.83579 10.5 8.25C10.5 8.66421 10.8358 9 11.25 9V7.5ZM15 9C15.4142 9 15.75 8.66421 15.75 8.25C15.75 7.83579 15.4142 7.5 15 7.5V9ZM3 9H8.25V7.5H3V9ZM11.25 9H15V7.5H11.25V9Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.25H9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.25H9",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25V13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25V13.5",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25L15.75 15.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25L15.75 15.75",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.732ad8e0c1d7481d82fc38f47d54ffed.svg";
export { ForwardRef as ReactComponent };